import useActionReducer from '@admin/hooks/use_action_reducer'
import * as selectors from './selectors'
import * as actions from './actions'
import PropTypes from 'prop-types'
import Carousel from './carousel'
import reducer from './reducer'
import React from 'react'

const CarouselContainer = (props) => {

  const [state, handlers] = useActionReducer({
    display_name: 'carousel',
    actions,
    props,
    reducer,
    selectors
  })

  const mergedProps = {
    ...props,
    ...state,
    ...handlers
  }

  return <Carousel { ...mergedProps } />

}

CarouselContainer.propTypes = {}

export default CarouselContainer